var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.58172 0 0 3.58172 0 8C0 12.4182 3.58172 16 8 16C12.4182 16 16 12.4182 16 8C16 3.58172 12.4182 0 8 0Z",
    fill: "#EE4444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 7.99967C4 7.63148 4.28277 7.33301 4.63158 7.33301H11.3684C11.7172 7.33301 12 7.63148 12 7.99967C12 8.36786 11.7172 8.66634 11.3684 8.66634H4.63158C4.28277 8.66634 4 8.36786 4 7.99967Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.9f20cccae7c4cbb7f47d9f45ba17c19d.svg";
export { ForwardRef as ReactComponent };